import React from 'react';
import { observer, inject } from 'mobx-react';

import { Link } from 'core/routing';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

import Button from 'components/Button';
import Tooltip from 'components/Tooltip';

import {
  MemberInfo,
  MemberText,
  MemberWrapper,
  CollaboratorAvatar,
  Name,
  Username,
  ButtonWrapper,
  ButtonStyled,
} from 'apps/group/styles';

export const GroupMember = inject('routerStore')(
  observer(({ member, group, groupDispName, routerStore }) => {
    const { profile, intrinsic, groupName, canDelete } = member.upstream;
    const { username, fullName, avatar, content, imageFallbackPath } = profile;
    const { RemoveMember } = group;

    const button =
      (groupName === 'admin' || groupName === 'owner') &&
      group.upstream.members.length === 1 ? (
        <Button
          data-tip={`The "${groupDispName}" group can't be empty!`}
          onClick={e => e.preventDefault()}
          size='small'
          text='Remove'
          disabled
        />
      ) : (
        <ButtonStyled
          onClick={e => {
            e.preventDefault();
            modalStore.SetModalComponent(ConfirmAction, {
              callBack: RemoveMember,
              callBackArgs: username,
              title: 'remove this User?',
              undo: true,
            });
          }}
          size='small'
          variant='destructive'
          text='Remove'
        />
      );

    const via = routerStore.route.params.initiative && (
      <span>{`(via ${routerStore.route.params.initiative})`}</span>
    );

    if (!intrinsic) return null;

    return (
      <MemberWrapper intrinsic={intrinsic}>
        <Tooltip delayShow={500} />
        <MemberInfo>
          <Link name='profile' params={{ profile: username }} content={content}>
            <CollaboratorAvatar
              src={imageSrc(
                avatar,
                imageFallbackPath,
                mainConf.imgSizes.profile.small,
              )}
            />
          </Link>
          <MemberText>
            <Name>
              {fullName} {intrinsic ? '' : via}
            </Name>
            <Link
              name='profile'
              params={{ profile: username }}
              content={content}
            >
              <Username intrinsic={intrinsic}>{username}</Username>
            </Link>
          </MemberText>
        </MemberInfo>
        {canDelete && <ButtonWrapper>{button}</ButtonWrapper>}
      </MemberWrapper>
    );
  }),
);
